import { render, staticRenderFns } from "./UrlUpdate.vue?vue&type=template&id=3b285ab5&scoped=true"
import script from "./UrlUpdate.vue?vue&type=script&lang=js"
export * from "./UrlUpdate.vue?vue&type=script&lang=js"
import style0 from "./UrlUpdate.vue?vue&type=style&index=0&id=3b285ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b285ab5",
  null
  
)

export default component.exports